import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  select: {
    width: '100%'
  }
};
const Dropdown = props => {
  const renderOptions = () => {
    if (props.options) {
      return props.options.map((option, i) => {
        return /*#__PURE__*/React.createElement("option", {
          key: i,
          value: option.get('value'),
          "data-testid": "option-".concat(i + 1)
        }, option.get('value'));
      });
    }
  };
  const change = e => props.onSelect(e.target.value);
  return /*#__PURE__*/React.createElement(NativeSelect, {
    className: props.classes.select,
    value: props.value,
    onChange: change,
    input: /*#__PURE__*/React.createElement(Input, {
      "data-testid": "select",
      name: "dropdown",
      id: "dropdown"
    }),
    "data-test": props.testClass
  }, /*#__PURE__*/React.createElement("option", {
    value: 0,
    "data-testid": "option-0"
  }), renderOptions());
};
export default withStyles(styles)(Dropdown);